import { render, staticRenderFns } from "./BaseCardLayout.vue?vue&type=template&id=f58f7348&scoped=true&"
import script from "./BaseCardLayout.vue?vue&type=script&lang=js&"
export * from "./BaseCardLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardLayout.vue?vue&type=style&index=0&id=f58f7348&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58f7348",
  null
  
)

export default component.exports